import {
  Container as OlxContainer,
  Row,
  Col,
} from '@olxbr/design-system';
import styled from 'styled-components';
import BackButton from 'components/atoms/back-button';

export const TitleRow = styled(Row)`
  margin-bottom: 2%;
  @media only screen and (max-width: 600px) {
    margin-bottom: 40px;
  }
`;

const Container = styled(OlxContainer)`
  margin-top: 72px;
  max-width: 1224px;
  @media only screen and (max-width: 600px) {
    margin-top: 32px;
  }
`;

const Wrapper = styled.div`
  height: 120px;
  @media only screen and (max-width: 600px) {
    height: 48px;
  }
`;

const Title = styled.h1`
  width: 100%;
  height: 32px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-top: 0px;
  margin-bottom: 8px;
`;

const Subtitle = styled.h2`
  width: 100%;
  height: 24px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #4a4a4a;
  display: contents;
`;

type Props = {
  children: any;
  title?: string;
  subtitle?: string;
  className?: string;
  backHandler?: Function;
};

const ContactUsContainer = (props: Props) => {
  const { children, title, subtitle, className, backHandler } = props;

  return (
    <Container className={className}>
      {/* @ts-ignore */}
      {backHandler ? <BackButton onClick={backHandler} /> : ''}
      <TitleRow>
        <Col xs={4} sm={8} md={8} lg={12} xl={12}>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Col>
      </TitleRow>
      <Row>
        <Col xs={4} sm={8} md={4} lg={6} xl={6}>
          {children}
        </Col>
      </Row>
      <Wrapper />
    </Container>
  );
};

ContactUsContainer.defaultProps = {
  title: 'Fale com a gente',
  subtitle: ``,
  className: '',
  backHandler: null,
};

export default ContactUsContainer;
